import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/ReansConsultingLogo-White.png';
import '../styles/Footer.css';

export default function Footer() {
  return (
    <footer className="footer mt-5 pt-5 pb-3">
      <div className="container">
        <div className="row">

          {/* Brand Column */}
          <div className="col-md-3 mb-4">
            <img src={logo} alt="Reans Consulting Logo" />
            <p className="small text-light">Smart Hiring Starts with the Right Partner.</p>
          </div>

          {/* SEO Services Column */}
          <div className="col-md-3 mb-4">
            <h6 className="fw-semibold text-white">Top Services</h6>
            <ul className="list-unstyled">
              <li><span className="footer-link">Employer of Record Malaysia</span></li>
              <li><span className="footer-link">Work Visa Application Support</span></li>
              <li><span className="footer-link">Payroll & HR Outsourcing</span></li>
              <li><span className="footer-link">Expatriate Visa Assistance</span></li>
              <li><span className="footer-link">Immigration Compliance Advisory</span></li>
              <li><span className="footer-link">Fast Talent Sourcing Malaysia</span></li>
              <li><span className="footer-link">Malaysia Workforce Expansion</span></li>
            </ul>
          </div>

          {/* Quick Links */}
          <div className="col-md-3 mb-4">
            <h6 className="fw-semibold text-white">Quick Links</h6>
            <ul className="list-unstyled">
              <li><Link to="/" className="footer-link">Home</Link></li>
              <li><Link to="/about" className="footer-link">About</Link></li>
              <li><Link to="/services" className="footer-link">Services</Link></li>
              <li><Link to="/expatriate-support" className="footer-link">Expat Support</Link></li>
              <li><Link to="/contact" className="footer-link">Contact</Link></li>
            </ul>
          </div>
          
          {/* Contact Info */}
          <div className="col-md-3 mb-4">
            <h6 className="fw-semibold text-white">Contact</h6>
            <p className="small text-light">
              <i className="bi bi-envelope-fill text-info"></i> norehan@reansconsult.com
            </p>
            <p className="small text-light">
              <i className="bi bi-telephone-fill text-success"></i> +6012 687 7057
            </p>
            <p className="small text-light">
              <i className="bi bi-geo-alt-fill text-danger"></i> 56-1-A, Jalan 7A/2, Bandar Tasik Puteri, Rawang, Selangor
            </p>
          </div>

        </div>

        {/* Bottom line */}
        <div className="text-center pt-3 border-top border-light-subtle mt-3">
          <small className="text-muted">
            &copy; {new Date().getFullYear()} Reans Consulting Sdn. Bhd. All rights reserved.
          </small>
        </div>
      </div>
    </footer>
  );
}
